import Anime from 'animejs/lib/anime.es.js'
import ScrollMonitor from 'scrollmonitor';

var css = '.ani { will-change: transform, opacity; }',
    head = document.head || document.querySelector('head'),
    style = document.createElement('style');

style.type = 'text/css';
style.appendChild(document.createTextNode(css));
head.appendChild(style);

window.onload = () => {

  if (window.matchMedia("(min-width: 1100px)").matches) {
    // ani-fade-up
    var fadeUp = {
      translateY: [15, 0],
      opacity: [0, 1],
      autoplay: false,
      easing: 'easeOutExpo',
      duration: 1500
    }

    // ani-fade-left
    var fadeLeft = {
      translateX: [15, 0],
      opacity: [0, 1],
      autoplay: false,
      easing: 'easeOutExpo',
      duration: 1500
    }

    // ani-fade-right
    var fadeRight = {
      translateX: [-15, 0],
      opacity: [0, 1],
      autoplay: false,
      easing: 'easeOutExpo',
      duration: 1500
    }

    // ani-fade-in
    var fadeIn = {
      opacity: [0, 1],
      autoplay: false,
      easing: 'easeOutExpo',
      duration: 1500
    }


    var animations = []
    var offset = -Math.abs(window.innerHeight * 0.3);
    var watchers = []

    function selectAnimationObject(a) {
      switch (true) {
        case a.classList.contains('ani-demo'):
          return demoAnimation;
        case a.classList.contains('ani-fade-up'):
          return fadeUp;
        case a.classList.contains('ani-fade-left'):
          return fadeLeft;
        case a.classList.contains('ani-fade-right'):
          return fadeRight;
        case a.classList.contains('ani-fade-in'):
          return fadeIn;
        default:
          return fadeIn;
      }
    }

    function adjustAnimationTiming(a) {
      switch (true) {
        case a.classList.contains('ani-delay-1'):
          return 1000
        case a.classList.contains('ani-delay-2'):
          return 2000
        case a.classList.contains('ani-delay-3'):
          return 3000
        case a.classList.contains('ani-delay-4'):
          return 4000
        case a.classList.contains('ani-delay-5'):
          return 5000
        case a.classList.contains('ani-delay-custom'):
          return 5000
        default:
          return 0
      }
    }

    var anis = document.querySelectorAll('.ani');

    anis.forEach((a, i) => {

      let targetAnimation = selectAnimationObject(a);

      targetAnimation.delay = adjustAnimationTiming(a);
      targetAnimation.targets = a;

      if ( a.classList.contains('ani-onload') ) {
        targetAnimation.delay += 1000;
        animations.push( Anime(targetAnimation) );
        animations[i].play();
        return;
      }

      if ( a.classList.contains('ani-onscroll') ) {
        animations.push( Anime(targetAnimation) );
        watchers.push({
          watcher: ScrollMonitor.create(animations[i].animatables[0].target, offset),
          indexTarget: i
        });
      }

    })

    for ( let i in watchers ) {
      watchers[i].watcher.enterViewport(() => {
        if (!animations[watchers[i].indexTarget].completed) {
          animations[watchers[i].indexTarget].play()
        }
      })
    }

    // Custom Styles Animation
    var aniStylesCustom = document.querySelector('.ani-styles-custom')

    var stylesAni = Anime({
      targets: '.styles-item.mod-ani',
      opacity: [0, 1],
      scale: [0.5, 1],
      duration: 1500,
      easing: 'easeOutExpo',
      autoplay: false,
      delay: Anime.stagger(400, {grid: [3, 3], from: 'first'}),
    });

    if( aniStylesCustom ) {

      var stylesWatcher = ScrollMonitor.create(aniStylesCustom, -Math.abs(window.innerHeight * 0.5))

      stylesWatcher.enterViewport(()=>{
        if ( !stylesAni.completed ) {
          stylesAni.play();
        }
      })
    }

    // Custom Projects Animation
    var aniProjectsCustom = document.querySelector('.ani-projects-custom')

    var projectsAni = Anime({
      targets: '.ani-projects-custom',
      opacity: [0, 1],
      scale: [0.75, 1],
      duration: 1500,
      easing: 'easeOutExpo',
      autoplay: false,
      delay: Anime.stagger(400, {grid: [1, 3], from: 'center'}),
    });

    if( aniProjectsCustom ) {

      var projectsWatcher = ScrollMonitor.create(aniProjectsCustom, -Math.abs(window.innerHeight * 0.3))

      projectsWatcher.enterViewport(()=>{
        if ( !projectsAni.completed ) {
          projectsAni.play();
        }
      })
    }
  }
}









